import { render, staticRenderFns } from "./KFieldGroup.vue?vue&type=template&id=0d95873e&"
import script from "./KFieldGroup.vue?vue&type=script&lang=js&"
export * from "./KFieldGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports